import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-professional-caregiver',
  templateUrl: './professional-caregiver.component.html',
  styleUrls: ['./professional-caregiver.component.css'],
})
export class ProfessionalCaregiverComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
